import VouchingDetails from "./VouchingDetails"

export default VouchingDetails
